module.exports = __webpack_public_path__ + "media/14-07-2016-philippenonnie-PyreneesFM.e5e098cc.mp3";